'use client'

import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { analytics } from '@/lib/analytics'

import type { User } from '@/services/http/usersService/types'
import { USER_INFO_COOKIE } from '@/utils/constants'

const isProduction = process.env.NODE_ENV === 'production'

function ErrorFallback() {
  return (
    <div
      role="alert"
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center"
    >
      <h1 className="text-xl font-semibold text-system-text-primary">
        Ops! Algo inesperado aconteceu
      </h1>
      <p className="text-system-text-secondary">
        Nossa equipe já foi notificada e está trabalhando para resolver isso.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-4 rounded-md bg-system-primary-purple px-6 py-2 text-white"
      >
        Recarregar página
      </button>
    </div>
  )
}

export function ErrorBoundaryWrapper({
  children,
}: {
  children: React.ReactNode
}) {
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    const raw = Cookies.get(USER_INFO_COOKIE) || 'null'
    setUser(JSON.parse(raw) as User)
  }, [])

  if (!isProduction) return <>{children}</>

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        analytics.captureException(
          error instanceof Error ? error : new Error(String(error)),
          {
            componentStack: info.componentStack ?? '',
            userId: user?.id ?? 'unknown',
            userEmail: user?.email ?? 'unknown',
          },
        )
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
